// import { Http } from "@angular/http";
import { Compiler, Injector, NgModule, SystemJsNgModuleLoader } from "@angular/core";
import { CommonModule } from "@angular/common";
import { Http } from "@angular/http";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { Router, RouterModule } from "@angular/router";
import { ClipboardModule } from "ngx-clipboard";
import {
    BlockUIModule,
    CalendarModule,
    CheckboxModule,
    DataTableModule,
    DialogModule,
    TooltipModule,
    LightboxModule,
    ListboxModule,
    PanelModule,
    RadioButtonModule
} from "primeng/primeng";

import { ITCITenantComponentOptions, QUERY_PARAMS, TCI_COMPONENT_MODE, TCITenantAppDetailsMenu } from "@tci/common";
import { NgWaitModule } from "../ng-shared/ng-components/ng-wait/ng-wait.module";
import { NgAuthGuardService } from "../ng-shared/ng-services/ng-auth-guard.service";
// import { NgTenantsGuardService } from "../ng-shared/ng-services/ng-tenants-guard.service";
import { NgSharedModule } from "../ng-shared/ng-shared.module";
import { TCITenantMenuServices } from "../ng-tenant/tci-tenant.menu";
import {
    BaseAppDetailComponentLoaderResolverInput,
    NgAppDetailsComponent,
    TCITenantDetailsDynLoaderComponent
} from "./ng-app-details.component";
import { NgAppPanelDeploymentComponent } from "./ng-app-panel-deployment/ng-app-panel-deployment.component";
import { NgHamburgerMenuModule } from "../ng-app-hamburger-menu/ng-app-hamburger-menu.module";
import { TciTenantRouteDeActivator } from "../ng-tenant/tci-tenant-route-de-activator.service";
import { TCIRouteSelectorResolver, TciTenantAppsRouteActivator } from "../tci-tenant-apps-route-activator";
import { TciTenantService } from "../ng-tenant/tci-tenant.service";
import { TCITenantRemoteServices } from "../ng-tenant/tci-tenant-remote-services";
import { TciTenantComponentCacheService } from "../ng-tenant/tci-tenant-component-cache.service";
import { NgAppDeployModule } from "../ng-app-deploy/ng-app-deploy.module";
import { NgContentEditableModule } from "../ng-shared/ng-directives/ng-content-editable/ng-content-editable.module";
import { NgClickOutsideModule } from "../ng-shared/ng-directives/ng-click-outside/ng-click-outside.module";
import { NgOnlyNumberModule } from "../ng-shared/ng-directives/ng-only-number/ng-only-number.module";
import { BaseAppDetailEndpointsService } from "./ng-app-tabs/ng-app-endpoints/base-app-detail-endpoints.service";
import { BaseAppDetailLogsService } from "./ng-app-tabs/ng-app-logs/base-app-detail-logs.service";
import { BaseAppDetailHistoryService } from "./ng-app-tabs/ng-apps-history/base-app-detail-history.service";
import { BaseAppExecHistoryService } from "./ng-app-tabs/ng-app-exec-history/base-app-exec-history.service";
import { BaseAppHMCopyService } from "../ng-app-hamburger-menu/ng-app-copy/base-app-hm-copy.service";
import { BaseMarketplaceCreateListingService } from "../ng-app-hamburger-menu/ng-marketplace-create-listing/base-marketplace-create-listing.service";
import { BaseAppHMReplaceService } from "../ng-app-hamburger-menu/ng-app-replace/base-app-hm-replace.service";
import { BaseAppHMChangeOwnerService } from "../ng-app-hamburger-menu/ng-app-change-owner/base-app-hm-change-owner.service";
import { BaseAppHMShareExternallyService } from "../ng-app-hamburger-menu/ng-app-share-externally/base-app-hm-share-externally.service";
import { NgAppListService } from "../ng-app-list/ng-app-list.service";
import { NgUserService } from "../ng-shared/ng-services/ng-user.service";
import { NgSecurityService } from "../ng-shared/ng-services/ng-security.service";
import { NgSubmenuLeftComponent } from "./ng-submenu-left/ng-submenu-left.component";
import { NgSubmenuLeftService } from "./ng-submenu-left/ng-submenu-left.service";
import { BaseSubmenuHybridConnService } from "./ng-app-tabs/ng-apps-env/submenu-left-tabs/ng-submenu-hybrid-conn/base-submenu-hybrid-conn.service";
import { BaseSubmenuEngVarsService } from "./ng-app-tabs/ng-apps-env/submenu-left-tabs/ng-submenu-eng-vars/base-submenu-eng-vars.service";
import { BaseSubmenuAppVpnService } from "./ng-app-tabs/ng-apps-env/submenu-left-tabs/ng-submenu-app-vpn/base-submenu-app-vpn.service";
import { BaseSubmenuAppVarsService } from "./ng-app-tabs/ng-apps-env/submenu-left-tabs/ng-submenu-app-vars/base-submenu-app-vars.service";
import { BaseSubmenuMonitoringFlowsService } from "./ng-app-tabs/ng-apps-monitoring/submenu-monitoring/ng-submenu-flows/base-submenu-flows.service";
import { BaseSubmenuMonitoringResourceMetricsService } from "./ng-app-tabs/ng-apps-monitoring/submenu-monitoring/ng-submenu-resource-metrics/base-submenu-resource-metrics.service";
import { BaseSubmenuMonitoringTriggersService } from "./ng-app-tabs/ng-apps-monitoring/submenu-monitoring/ng-submenu-triggers/base-submenu-triggers.service";
import { NgAppFeatureToggleService } from "../ng-shared/ng-services/ng-app-feature-toggle.service";
import { BaseAppDetailElasticLogsService } from "./ng-app-tabs/ng-app-elastic-logs/base-app-detail-elastic-logs.service";
// import { TciTenantModelService } from "../ng-tenant/tci-tenant.model";
// import { NgWebSocketService } from "../ng-shared/ng-services/ng-websocket.service";
// import { NgEnvVarsService } from "../ng-shared/ng-services/ng-env-vars.service";

function TciAppDetailsTenantRouteActivatorFactory(
    parentInjector: Injector,
    loader: SystemJsNgModuleLoader,
    compiler: Compiler,
    tenantRemoteServices: TCITenantRemoteServices,
    tenantSvc: TciTenantService,
    tenantCacheService: TciTenantComponentCacheService,
    tenantMenuSrv: TCITenantMenuServices,
    appsAPISrv: NgAppListService,
    userService: NgUserService,
    authSvc: NgAuthGuardService,
    router: Router,
    featureToggleService: NgAppFeatureToggleService) {
    const routeResolver: TCIRouteSelectorResolver = (input: string) => {
        if (input === QUERY_PARAMS.DEFAULT_ROUTE) { // Skip component verification if it's "default" constant
            return;
        }

        const items = TCITenantAppDetailsMenu
            .getAllMenuItems()
            .filter(item => item.getRouteId() === input);
        if (items && items.length > 1) {
            throw new Error("Duplicate routes found for :" + input);
        }
        return items
            .pop();
    };

    const inputResolver: any = (input, apptype, compOptions: ITCITenantComponentOptions<any>) =>
        appsAPISrv.getResolverAppData(input, apptype).map(appData =>
            new BaseAppDetailComponentLoaderResolverInput(
                appData.type,
                compOptions.getComponentSelectorType(),
                appData,
                userService,
                featureToggleService,
                TCI_COMPONENT_MODE.COMP_MODE_APP_DEFAULT,
                undefined,
                null
            )
        );

    return new TciTenantAppsRouteActivator(
        parentInjector,
        loader,
        compiler,
        tenantRemoteServices,
        tenantSvc,
        tenantCacheService,
        tenantMenuSrv,
        authSvc,
        router,
        routeResolver,
        inputResolver
    );
}

function TciAppDetailsTenantRouteDeActivatorFactory(
    parentInjector: Injector,
    loader: SystemJsNgModuleLoader,
    compiler: Compiler,
    tenantRemoteServices: TCITenantRemoteServices,
    tenantSvc: TciTenantService,
    tenantCacheService: TciTenantComponentCacheService,
    appsAPISrv: NgAppListService,
    userService: NgUserService,
    router: Router
) {
    return TciTenantRouteDeActivator.getInstance();
}
function BaseAppExecHistoryServiceFactory(
    http: Http
) {
    return BaseAppExecHistoryService.getInstance(http);
}

// function NgAppDetailsTenantGuard(router: Router, tenantMenuSrv: TCITenantMenuServices) {
//     const tenantGuardSrvInstance = new NgTenantsGuardService(router, tenantMenuSrv);
//
//     const menuItensFn = (arg) => tenantMenuSrv.getAppDetailMenuItems(arg);
//     tenantGuardSrvInstance.setMenuItemsFn(menuItensFn);
//     tenantGuardSrvInstance.setTCIMenuTypeComponents(TCITenantAppDetailsMenu);
//
//     return tenantGuardSrvInstance;
// }

/* function TciBaseSubmenuMonitorResourceMetricsService(
    http: Http,
    tenantSvc: TciTenantService,
    tenantModelSvc: TciTenantModelService,
    wsService: NgWebSocketService,
    envVarsSvc: NgEnvVarsService
) {
    return BaseSubmenuMonitoringResourceMetricsService.getInstance(
        http, tenantSvc, tenantModelSvc, wsService, envVarsSvc
    );
} */

@NgModule({
    imports: [
        BlockUIModule,
        NgClickOutsideModule,
        NgOnlyNumberModule,
        ClipboardModule,
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        RouterModule.forChild([
            {
                path: "applications/details/:routeid/:inputid",
                component: NgAppDetailsComponent,
                canActivate: [
                    // NgAuthGuardService,
                    // NgAppDetailsTenantGuard,
                    TciAppDetailsTenantRouteActivatorFactory
                ],
                canDeactivate: [
                    TciTenantRouteDeActivator
                ]
            },
            {
                path: "applications/details/**",
                canActivate: [
                    NgAuthGuardService,
                    // NgAppDetailsTenantGuard
                ],
                redirectTo: "applications"
            }
        ]),
        CalendarModule,
        DataTableModule,
        DialogModule,
        TooltipModule,
        LightboxModule,
        ListboxModule,
        NgWaitModule,
        NgHamburgerMenuModule,
        NgAppDeployModule,
        NgSharedModule.forRoot(),
        PanelModule,
        CheckboxModule,
        RadioButtonModule,
        NgContentEditableModule
    ],
    declarations: [
        TCITenantDetailsDynLoaderComponent,
        NgAppDetailsComponent,
        NgAppPanelDeploymentComponent,
        NgSubmenuLeftComponent
    ],
    providers: [
        TCITenantMenuServices,
        TciTenantRouteDeActivator,
        NgSubmenuLeftService,
        // {
        //     provide: NgAppDetailsTenantGuard,
        //     useFactory: NgAppDetailsTenantGuard,
        //     deps: [Router, TCITenantMenuServices]
        // },
        {
            provide: TciAppDetailsTenantRouteActivatorFactory,
            useFactory: TciAppDetailsTenantRouteActivatorFactory,
            deps: [
                Injector,
                SystemJsNgModuleLoader,
                Compiler,
                TCITenantRemoteServices,
                TciTenantService,
                TciTenantComponentCacheService,
                TCITenantMenuServices,
                NgAppListService,
                NgUserService,
                NgAuthGuardService,
                Router,
                NgAppFeatureToggleService
            ]
        },
        {
            provide: TciTenantRouteDeActivator,
            useFactory: TciAppDetailsTenantRouteDeActivatorFactory,
            deps: [
                Injector,
                SystemJsNgModuleLoader,
                Compiler,
                TCITenantRemoteServices,
                TciTenantService,
                TciTenantComponentCacheService,
                NgAppListService,
                NgUserService,
                Router
            ]
        },
        NgSecurityService,
        BaseAppDetailLogsService,
        BaseAppDetailElasticLogsService,
        BaseAppDetailHistoryService,
        {
            provide: BaseAppExecHistoryService,
            useFactory: BaseAppExecHistoryServiceFactory,
            deps: [
                Http
            ]
        },
        BaseAppDetailEndpointsService,
        BaseSubmenuHybridConnService,
        BaseSubmenuEngVarsService,
        BaseSubmenuAppVpnService,
        BaseSubmenuAppVarsService,
        BaseAppHMReplaceService,
        BaseAppHMCopyService,
        BaseMarketplaceCreateListingService,
        BaseAppHMChangeOwnerService,
        BaseAppHMShareExternallyService,

        // Monitoring
        BaseSubmenuMonitoringFlowsService,
        BaseSubmenuMonitoringResourceMetricsService,
        /* {
            provide: BaseSubmenuMonitoringResourceMetricsService,
            useFactory: TciBaseSubmenuMonitorResourceMetricsService,
            deps: [
                Http,
                TciTenantService,
                TciTenantModelService,
                NgWebSocketService,
                NgEnvVarsService
            ]
        }, */
        BaseSubmenuMonitoringTriggersService
    ],
    exports: [
        RouterModule,
        NgSubmenuLeftComponent,
        TCITenantDetailsDynLoaderComponent
    ]
})
export class NgAppDetailsModule {
}
